import styled, { css } from 'styled-components';
import { Loader as LoaderComponent } from 'src/components';

export const Root = styled.div<{ $transparent?: boolean }>(
  ({ theme, $transparent }) => css`
    align-items: center;
    /* Flush video sessions: match the video matte so gaps never flash page white. */
    background-color: ${$transparent ? '#000' : theme.co.neutral99};
    color: ${theme.co.neutral20};
    display: flex;
    flex-direction: column;
    font-size: ${theme.sz.s3};
    height: 100%;
    min-height: 100dvh;
    min-width: 100%;
    width: 100%;

    ${
      $transparent &&
      css`
        flex: 1;
      `
    }
  `,
);

export const Content = styled.div<{ $flush?: boolean }>(
  ({ theme, $flush }) => css`
    box-sizing: border-box;
    /* Flush (full-bleed video): side padding only — bottom padding left a white strip
       under the fixed video. Docked controls supply their own bottom inset. */
    padding: ${$flush ? `0 ${theme.sz.s4}` : theme.sz.s4};
    width: 100%;

    @media (min-width: ${theme.sz.ml}) {
      padding: ${$flush ? `0 ${theme.sz.s8}` : theme.sz.s8};
    }

    ${
      $flush &&
      css`
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;

        /* Fill remaining viewport height so docked side controls can pin to the bottom. */
        & > * {
          flex: 1;
          min-height: 0;
          width: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
        }

        @media (max-width: ${theme.sz.md}) {
          min-height: auto;
          overflow-y: auto;

          & > * {
            flex: 1 0 auto;
            min-height: auto;
          }
        }
      `
    }
  `,
);

export const Loader = styled(LoaderComponent)`
  margin-top: ${props => props.theme.sz.s40};
  width: ${props => props.theme.sz.s12};

  @media (min-width: ${props => props.theme.sz.xl}) {
    width: ${props => props.theme.sz.s40};
  }
`;

export const Error = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: ${theme.sz.ms};
    background-color: ${theme.co.primary99};
    border-radius: ${theme.sz.s4};
    color: ${theme.co.secondary20};
    font-size: ${theme.DEPRECATED_ty.mediumLarge};
    font-weight: ${theme.DEPRECATED_ty.mediumWeight};
    padding: ${theme.sz.s8};
    z-index: ${theme.zi.z7};
  `,
);

export const ErrorReportBugLink = styled.a(
  ({ theme }) => css`
    display: flex;
    font-size: ${theme.DEPRECATED_ty.small};
    align-items: center;
  `,
);
